import { DeleteOutlined, FileOutlined, SendOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Space, Typography } from "antd";
import { MazakaButton } from "apps/Common/MazakaButton";

import { useState } from "react";
import ImageUploader from "./ImageUploader";
import TextArea from "antd/es/input/TextArea";
import { UploadFile } from "antd/lib";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { RootState } from "store/Reducers";
import { useDispatch, useSelector } from "react-redux";
import { sendMessage } from "apps/RealState/Details/Services";
import { handleSetMessageDetaisList } from "../../ClientSideStates";

const SendMessage = () => {
  const [fileList, setFileList] = useState<any[]>([]);
  const { messageDetilsFilter, messageDetailsListData } = useSelector(
    (state: RootState) => state.message
  );
  const { userInfoes } = useSelector((state: RootState) => state.profile);
  const [form] = Form.useForm();
  const { Text } = Typography;
  const dispatch = useDispatch();

  const handleRemove = (file: UploadFile) => {
    const updatedFileList = fileList.filter((item) => item.uid !== file.uid);
    setFileList(updatedFileList);
  };

  const truncateFileName = (name: string, maxLength = 20) => {
    if (name.length <= maxLength) return name;
    return `${name.substring(0, maxLength)}...${name.split('.').pop()}`;
  };

  const convertFilesToBase64 = (files: UploadFile[]) => {
    const promises = files.map((file) => {
      return new Promise<string>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj as Blob);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
      });
    });

    return Promise.all(promises).catch(console.error);
  };

const handleOnFinish = async () => {
  let formValues = form.getFieldsValue();
  const messageContent = (formValues["message"] || "").trim();  // Null, undefined ve boşlukları temizle

  const currentMessageList: any = JSON.parse(JSON.stringify(messageDetailsListData));

  try {
    const fileListImageSrc = await convertFilesToBase64([...fileList]) || [];
    const data: any = {
      message: messageContent,  // Garantili string
      sentUserId: messageDetilsFilter.ContactUserId,
      advertId: messageDetilsFilter?.AdvertId,
      senderUserId: userInfoes?.id,
      messageFiles: [...fileListImageSrc],
      ownerId: currentMessageList?.ownerId,
      isOwnerMessage: currentMessageList?.ownerId === userInfoes.id,
      isContactMessage: currentMessageList?.ownerId !== userInfoes.id,
      ownerPhotoUrl: currentMessageList?.ownerId === userInfoes.id ? userInfoes.photoUrl : null,
      contactPhotoUrl: currentMessageList?.ownerId !== userInfoes.id ? userInfoes.photoUrl : null
    };

    if (!currentMessageList.advertMessages) {
      currentMessageList.advertMessages = [];
    }

    currentMessageList.advertMessages.push({ ...data });

    const formData = new FormData();
    formData.append("message", messageContent);  // Burada da garanti altına aldık
    formData.append("advertId", messageDetilsFilter?.AdvertId);
    formData.append("senderUserId", userInfoes?.id);
    formData.append("sentUserId", messageDetilsFilter.ContactUserId);

    if (fileList && fileList.length > 0) {
      fileList.forEach((file) => {
        formData.append("messageFiles", file.originFileObj);
      });
    }

    await sendMessage(formData, true);
    currentMessageList.advertMessages[currentMessageList.advertMessages.length - 1]["isSaved"] = true;

    dispatch(handleSetMessageDetaisList({ data: currentMessageList }));
    form.resetFields();
    setFileList([]);
  } catch (error: any) {
    openNotificationWithIcon("default", error?.message || error?.title);
    console.log("Hata oluştu:", error);
  }
};

  
  return (
  <Row
  className={`!w-full ${
    fileList.length > 8
      ? 'pt-[150px]'
      : fileList.length > 4
      ? 'pt-[80px]'
      : fileList.length > 0
      ? 'pt-[30px]'
      : ''
  }`}
>
      <Col xs={24}>
        <Form
          onFinish={handleOnFinish}
          form={form}
          className="!flex gap-2 items-center !w-full"
        >
          <ImageUploader fileList={fileList} setFileList={setFileList} />
          <Form.Item className="!w-full" name={"message"} rules={[{message:""}]}>
            <TextArea
              name="message"
              className="!w-full"
              placeholder="Mesajını Yaz..."
              autoSize
            />
          </Form.Item>

          <Button
            htmlType="submit"
            className="!bg-black text-white"
          >
            <div className="!flex justify-center gap-2">
              <SendOutlined className="!text-white"/>
              <Text className="!text-white !hidden md:!inline">Gönder</Text>
            </div>
          </Button>
        </Form>
      </Col>

      <Col xs={24} className="">
        {fileList.length > 0 && (
          <div className="!max-h-30 !overflow-y-auto !border !border-gray-200 !rounded !p-2 !mt-2">
            <Row gutter={[8, 8]} className="!w-full">
              {fileList.map((item) => (
                <Col key={item.uid} xs={24} sm={12} md={8} lg={6} className="!flex !items-center !justify-between !gap-2 !p-1 !border-b !border-gray-100 last:!border-0">
                  <div className="!flex !items-center !gap-2 !truncate">
                    <FileOutlined className="!text-indigo-500 !flex-shrink-0" />
                    <Text className="!text-md !truncate" title={item.name}>
                      {truncateFileName(item.name)}
                    </Text>
                  </div>
                  <Button
                    type="text"
                    icon={<DeleteOutlined className="!text-red-600" />}
                    onClick={() => handleRemove(item)}
                    size="small"
                  />
                </Col>
              ))}
            </Row>
          </div>
        )}
      </Col>
    </Row>
  );
};

export default SendMessage;